export default __webpack_public_path__ + "static/media/home-d.8fc5e71b.svg";